// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { withRouter } from 'react-router';


import { StudentApi } from "../../../util/api/StudentApi";
import SimpleField from '../../forms/SimpleField';
import BackButton from "../../widgets/BackButton";

import { Alert } from "../../../store/Alert";

import Student from "../../../store/wrappers/Student";



class StudentForm extends Component {
    static displayName = StudentForm.name;

    constructor(props) {
        super(props);

        //Assume we're creating a new student unless the user provided a valid id as a url argument
        let student = false;
        let displayMode = "new";
        if (this.props.match.params.id) {
            student = this.props.store.students.getById(this.props.match.params.id);
            displayMode = "edit";
        }


        this.state = {
            loading: true,
            student: student,
            mode: displayMode
        };

        if (displayMode == "new") {
            this.props.store.updateBanner("Add New");
        }
        else {
            this.props.store.updateBanner("Update Student", student.name);
        }

        this.deleteStudent = this.deleteStudent.bind(this);
    }

    async deleteStudent(e) {
        if (window.confirm("Are you sure you'd like to remove this student from SWS?")) {
            const studentId = e.target.value;
            console.log(e)

            await StudentApi.delete(studentId);

            await this.props.store.getFromApi(["students"])

            this.props.history.goBack();

            let successAlert = new Alert("Successfully deleted student");

        }
    }

    //Rerender if we're going from edit to new state
    /*componentDidUpdate(prevProps, prevState) {
        if (prevProps.mode !== this.props.mode && !this.props.match.params.id) {
            this.setState({ student: null });
        }
    }*/

    setInitialValues() {
        let student = this.state.student;
        if (!student) {
            student = new Student()
            console.log("no student, setting initial values to blank")
        }

        return {
            id: student.id || "",
            tuid: student.tuid || "",
            firstName: student.firstName || "",
            middleName: student.middleName || "",
            lastName: student.lastName || "",
            suffix: student.suffix || "",
            email: student.email || "",

            awardAmount: student.awardAmount || 0,

        }
    }

    async handleSubmission(values, setSubmitting, resetForm) {
        this.setState({ setSubmitting: true });

        //If the user creates a new employer, the form doesn't get rerendered. That would be easy!

        if (values.id == "" && this.state.student.id) {
            values.id = this.state.student.id;
        }


        let student = new Student(values, true);

        student = await student.save(this.props.store);

        console.log(student);

        //If there aren't any errors, and we're adding students. 
        if (this.state.mode == "new" && student.errors == null || student.errors.length == 0) {
            console.log("added new student")
            resetForm()
            this.setState({ setSubmitting: false });
        }
        else if (this.state.mode == "edit" && student.errors == null || student.errors.length == 0) {
            console.log("updated student")

            this.setState({
                student: student,
                setSubmitting: false,
                mode: "edit"
            });
        }
    }

    validate(values) {
        const errors = {};

        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.form()}
                    </div>
                </div>
            </div>
        )
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Student</h1>
                </React.Fragment>
            )
        }
        return (undefined);
    }

    form() {
        return (
            (this.state.mode == "new" || this.state.student ? (
                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting, resetForm)}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field name="id" className="form-control" type="hidden" />

                            <SimpleField name="tuid" label="TUID" />

                            <SimpleField name="firstName" label="First Name" />
                            <SimpleField name="middleName" label="Middle Name (optional)" />
                            <SimpleField name="lastName" label="Last Name" />

                            <SimpleField name="email" type="email" />

                            <SimpleField name="suffix" label="Suffix (optional)" />

                            <SimpleField name="awardAmount" label="Award Amount" type="number" step="0.01" />

                            <div className="staffFormSubmitButtons">
                                {this.state.mode !== "new" &&
                                    <React.Fragment>
                                        <BackButton className="btn btn-secondary mr-2" innerText="Cancel" />
                                        <button value={this.props.match.params.id} type="button" onClick={this.deleteStudent} className="btn btn-secondary mr-2">Delete Student</button>
                                    </React.Fragment>
                                }
                                <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            ) :
                (
                    <div>
                        <h3>Could not find student</h3>
                    </div>
                )
            )
        );
    }
}

StudentForm = withRouter(StudentForm)
export { StudentForm };